var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wf-product-category-refinements sticky-top filterPadding" },
    _vm._l(_vm.availableFilters, function(filter) {
      return _c(
        "div",
        {
          key: filter.name,
          staticClass:
            "wf-product-refinement-list wf-product-refinement-list-expanded"
        },
        [
          _c("div", { staticClass: "wf-product-refinement-list-header" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn wf-product-refinement-list-header-toggle collapsed",
                attrs: {
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target":
                    ".wf-product-refinement-collapse-" +
                    filter.azureFilterName
                      .toLowerCase()
                      .replace(/[^\w ]+/g, "")
                      .replace(/ +/g, "-")
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(filter.name) +
                    "\n                "
                ),
                _c("span", {
                  staticClass:
                    "png-icon png-icon-icons-glyph--k-btn-minus-active wf-product-refinement-list-header-toggle-inactive"
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass:
                    "png-icon png-icon-icons-glyph--k-btn-expand-ol wf-product-refinement-list-header-toggle-active"
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "wf-product-refinement-list-items collapse",
              class:
                "wf-product-refinement-collapse-" +
                filter.azureFilterName
                  .toLowerCase()
                  .replace(/[^\w ]+/g, "")
                  .replace(/ +/g, "-")
            },
            [
              _c(
                "div",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "showMoreLabel",
                        fn: function(ref) {
                          var isShowingMore = ref.isShowingMore
                          return _c("div", {}, [
                            isShowingMore
                              ? _c(
                                  "div",
                                  { staticClass: "btn view-more-button" },
                                  [
                                    _c("span", { staticClass: "mr-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.search.side.filters.view.less"
                                          ]
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass:
                                        "png-icon png-icon-icons-glyph--red-btn-minus-active"
                                    })
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "btn view-more-button" },
                                  [
                                    _c("span", { staticClass: "mr-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.search.side.filters.view.more"
                                          ]
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass:
                                        "png-icon png-icon-icons-glyph--red-btn-expand-active"
                                    })
                                  ]
                                )
                          ])
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "wf-product-refinement-list-item custom-control custom-checkbox"
                    },
                    _vm._l(filter.options, function(item) {
                      return _c("div", { key: filter.name + "-" + item }, [
                        _c("input", {
                          staticClass: "custom-control-input",
                          attrs: {
                            type: "checkbox",
                            id: filter.name + "-" + item
                          },
                          domProps: {
                            value: item,
                            checked:
                              _vm.selectedFilters[filter.azureFilterName] &&
                              _vm.selectedFilters[filter.azureFilterName].some(
                                function(i) {
                                  return i.toLowerCase() === item.toLowerCase()
                                }
                              )
                          },
                          on: {
                            click: function($event) {
                              return _vm.onFilterClick({
                                filterName: filter.azureFilterName,
                                option: item
                              })
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label",
                            attrs: {
                              "data-data": filter.azureFilterName,
                              for: filter.name + "-" + item
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(item) +
                                "\n                        "
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }